// extracted by mini-css-extract-plugin
export default {"contact-form":"ContactForm_contact-form__6qa+j","form-control":"ContactForm_form-control__Cpu9A","submit-btn":"ContactForm_submit-btn__TLTVx"};